<template>
  <div data-v-469af010="" class="lowest-level">
    <div data-v-469af010="">
      <img data-v-469af010="" src="https://image.insideburgundy.cn/footLogo.png" alt="" style="margin-top: 25px" />
    </div>
    <div data-v-469af010="" class="lowest-level-shang">
      <span data-v-469af010="">
        <a href="#/JASPER" style="text-decoration: none; color: #fff">关于Inside Burgundy</a>
      </span>
      <span data-v-469af010=""><a href="#/Burgundy" style="text-decoration: none; color: #fff">关于勃艮第</a></span>
      <span data-v-469af010=""><a href="#/theactivity" style="text-decoration: none; color: #fff">最新活动</a></span>
      <span data-v-469af010=""><a href="#/Appraisal" style="text-decoration: none; color: #fff">品鉴报告</a></span>
      <span data-v-469af010=""><a href="#/report" style="text-decoration: none; color: #fff">最新资讯</a></span>
      <span data-v-469af010=""><a href="#/Subscribe" style="text-decoration: none; color: #fff">订阅</a></span>
    </div>
    <div data-v-469af010="" class="lowest-level-xia">
      <span data-v-469af010=""><a href="#/Faqs" style="text-decoration: none; color: #fff">常见问题解答</a></span>
      <span data-v-469af010="">条款与条件</span>
      <span data-v-469af010="">隐私政策</span>
    </div>
    <a
      data-v-469af010=""
      style="text-decoration: none; color: #fff"
      href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ beian }}
    </a>
  </div>
</template>

<script>
// insideburgundy.cn 沪ICP备19007338号-1
// insideburgundy.com.cn  沪ICP备2022029318号-2

export default {
  computed: {
    beian () {
      const host=window.location.host
      console.log(host.includes('insideburgundy.com.cn'))
      if (host.includes('insideburgundy.com.cn')) {
        return '沪ICP备2022029318号-2'
      }
      return '沪ICP备2022029318-1'
    }
  },
  methods: {
    toUrl () {
      window.location.href = 'https://beian.miit.gov.cn/#/Integrated/index'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/template/footer.vue